export default {
  install (Vue, config) {
    Vue.prototype.$_hostApp_config = config
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/index.js